import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [procurementOpen, setProcurementOpen] = useState(false);
  return <header className="bg-white border-b border-gray-border sticky top-0 z-50" data-id="element-257">
      <div className="max-w-7xl mx-auto px-4" data-id="element-258">
        <div className="flex items-center justify-between h-20" data-id="element-259">
          <Link to="/" className="flex items-center gap-3" data-id="element-260">
            <img src="https://cdn.magicpatterns.com/uploads/dUQRpLPA28c7QtfR6xGyBP/Logo.png" alt="African Union Commission" className="w-12 h-12 object-contain" data-id="element-261" />
            <div data-id="element-262">
              <div className="font-serif text-xl font-bold" style={{
              color: '#8B1A2C'
            }} data-id="element-263">
                African Union
              </div>
              <div className="text-sm text-gray-600" data-id="element-264">Commission</div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8" data-id="element-265">
            <Link to="/" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-266">
              Home
            </Link>
            <Link to="/about" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-267">
              About
            </Link>
            <Link to="/projects" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-268">
              Projects
            </Link>
            <Link to="/bids" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-269">
              Bids & Tenders
            </Link>

            <div className="relative" onMouseEnter={() => setProcurementOpen(true)} onMouseLeave={() => setProcurementOpen(false)} data-id="element-270">
              <button className="flex items-center gap-1 text-charcoal hover:text-au-green transition-colors font-medium py-2" data-id="element-271">
                Procurement
                <ChevronDownIcon size={16} data-id="element-272" />
              </button>

              {procurementOpen && <div className="absolute top-full left-0 pt-2 w-56 z-50" data-id="element-273">
                  <div className="bg-white rounded-lg shadow-lg border border-gray-border py-2" data-id="element-274">
                    <Link to="/procurement/annual-plan" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-275">
                      Annual Plan
                    </Link>
                    <Link to="/procurement/contract-awards" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-276">
                      Contract Awards
                    </Link>
                    <Link to="/procurement/unsuccessful-bids" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-277">
                      Unsuccessful Bids
                    </Link>
                    <Link to="/procurement/manual" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-278">
                      Procurement Manual
                    </Link>
                    <Link to="/procurement/supplier-registration" className="block px-4 py-2 hover:bg-au-green-light transition-colors" data-id="element-279">
                      Expression of Interest (EOI)
                    </Link>
                  </div>
                </div>}
            </div>

            <Link to="/contact" className="text-charcoal hover:text-au-green transition-colors font-medium" data-id="element-280">
              Contact
            </Link>
          </nav>

          <button className="lg:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-281">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-282" /> : <MenuIcon size={24} data-id="element-283" />}
          </button>
        </div>

        {mobileMenuOpen && <nav className="lg:hidden py-4 border-t border-gray-border" data-id="element-284">
            <Link to="/" className="block py-2 hover:text-au-green transition-colors" data-id="element-285">
              Home
            </Link>
            <Link to="/about" className="block py-2 hover:text-au-green transition-colors" data-id="element-286">
              About
            </Link>
            <Link to="/projects" className="block py-2 hover:text-au-green transition-colors" data-id="element-287">
              Projects
            </Link>
            <Link to="/bids" className="block py-2 hover:text-au-green transition-colors" data-id="element-288">
              Bids & Tenders
            </Link>
            <div className="py-2" data-id="element-289">
              <div className="font-medium mb-2" data-id="element-290">Procurement</div>
              <Link to="/procurement/annual-plan" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-291">
                Annual Plan
              </Link>
              <Link to="/procurement/contract-awards" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-292">
                Contract Awards
              </Link>
              <Link to="/procurement/unsuccessful-bids" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-293">
                Unsuccessful Bids
              </Link>
              <Link to="/procurement/manual" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-294">
                Procurement Manual
              </Link>
              <Link to="/procurement/supplier-registration" className="block py-1 pl-4 hover:text-au-green transition-colors" data-id="element-295">
                Expression of Interest (EOI)
              </Link>
            </div>
            <Link to="/contact" className="block py-2 hover:text-au-green transition-colors" data-id="element-296">
              Contact
            </Link>
          </nav>}
      </div>
    </header>;
}